import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export const useDeleteCustomer = (successCallback?: () => void): UseMutationResult<null, Error, { id: number }, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);
    return useMutation<null, Error, { id: number }>({
        mutationFn: async ({ id }: { id: number }) => {
            const response = await axios.delete(`${enum_api_uri.delete_customer}/${id}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerList"] });
            successCallback?.();
        },
    });
};
